module.exports = __webpack_public_path__ + "static/phone-mock-07d05ebc89a863d439c38be89c216162.png";